import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { Router, ActivatedRoute } from '@angular/router';
import { FcComponent } from '../fc';
@Component({
    selector: 'fc-addetail',
    template: `

    `,
    styles: [`
    `]
})
export class FcaddetailComponent extends FcComponent {
     /**åæ°æ®id*/
    @Input()
    fcId: string;
     /**åæ°æ®id*/
    @Input()
    fcAppid: string;
    @Input()
    fcApp: string;
    @Input()
    fcFieldCode: string;
    @Input()
    fcLinks:string;
    fcField: any;
    mainObj: any;
    fcTitle: string;
    toolbar: any[];
    footer: any;
    constructor(public provider: ProvidersService,
        public router: Router, public activatedRoute: ActivatedRoute) {
        super(provider,"fc-addetail");
        activatedRoute.paramMap.subscribe(paramMan => { this.fcId = paramMan.get("id") });
    }
    _init(){
    }
    /**
     * åå§ååå®¹
     */
    ngOnChanges(param): void {
         /**åå§åfcApp*/
        this.fcApp = this.provider.appService.apps[this.fcAppid];
        if (this.fcApp === void 0) {
            this.pushDestroy(this.provider.appService.findAppByAid(this.fcAppid).subscribe(result => {
                if (result.CODE === '0' && result.DATA !== void 0) {
                    this.fcApp = result.DATA[0];
                    this.init();
                }
            }));
        } else {
            this.init();
        }

    }

    /**
     * åå§åæ é¢ååºç¨å³è
     */
    private init(): void {
        this.fcLinks = this.fcApp['SYSAPPLINKS'];
        this.fcTitle = this.fcApp['APPNAME'] + "è¯¦æ";
    }
    /**
     * åå§åä¸»å¯¹è±¡
     */
    initMainObj(): void {
        this.pushDestroy(this.provider.appService.findWithQuery(this.fcAppid, { ID: this.fcId }).subscribe(result => {
            if (result !== void 0 && result.DATA.length !== 0) {
                this.mainObj = result.DATA[0];
            }
        }));
    }
    confirm(): void {
        throw new Error("Method not implemented.");
    }
    cancel(): void {
        throw new Error("Method not implemented.");
    }
    close(): void {
        throw new Error("Method not implemented.");
    }
    back(): void {
        throw new Error("Method not implemented.");
    }
    next(): void {
        throw new Error("Method not implemented.");
    }
    prev(): void {
        throw new Error("Method not implemented.");
    }

}
